import { BaseServices, HttpMethod } from '@services/base'

export interface DocAnexoType {
  type: string
  files: Files[]
}

export interface Files {
  file: string
  extension: string
}

export type PostEnviarDocumentosWebServiceType = (
  data: DocAnexoType,
  cpf: string,
  accessToken?: string,
) => Promise<unknown>

export default async (data: DocAnexoType, cpf: string, accessToken?: string) => {
  const pathname = process.env.REACT_APP_ENVIAR_ANEXO_WEB
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
    socialDocument: cpf,
  }

  const response = await BaseServices.request({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}
